// Años disponibles para los indicadores.
//
// Antes esta lista estaba escrita a mano en dos sitios (el select de "Año" del
// formulario y el filtro del listado) y se quedo congelada en 2023: desde 2024
// no se podia crear ni filtrar un indicador del año en curso.
//
// Se genera desde 2020 (el primer año con indicadores) hasta el año siguiente al
// actual, para poder dejar montados los indicadores del año que viene.
const FIRST_YEAR = 2020;

export const indicatorYears = () => {
    const lastYear = new Date().getFullYear() + 1;
    const years = [];

    for (let year = FIRST_YEAR; year <= lastYear; year++) {
        years.push(String(year));
    }

    return years;
}

// Mismo listado con el formato { label, value } que espera react-select.
export const indicatorYearOptions = () => (
    indicatorYears().map((year) => ({ label: year, value: year }))
)
